import { render, staticRenderFns } from "./ColorCell.vue?vue&type=template&id=8edb9980&"
import script from "./ColorCell.vue?vue&type=script&lang=ts&"
export * from "./ColorCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports